export default "__VITE_ASSET__CrZOeTz6__"